"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.oAuthSignOutRedirect = void 0;
const utils_1 = require("@aws-amplify/core/internals/utils");
const utils_2 = require("../../../../utils");
const getRedirectUrl_1 = require("./getRedirectUrl");
const oAuthSignOutRedirect = async (authConfig, preferPrivateSession = false, redirectUrl) => {
    (0, utils_1.assertOAuthConfig)(authConfig);
    const { loginWith, userPoolClientId } = authConfig;
    const { domain, redirectSignOut } = loginWith.oauth;
    const signoutUri = (0, getRedirectUrl_1.getRedirectUrl)(redirectSignOut, redirectUrl);
    const oAuthLogoutEndpoint = `https://${domain}/logout?${Object.entries({
        client_id: userPoolClientId,
        logout_uri: encodeURIComponent(signoutUri),
    })
        .map(([k, v]) => `${k}=${v}`)
        .join('&')}`;
    return (0, utils_2.openAuthSession)(oAuthLogoutEndpoint, redirectSignOut, preferPrivateSession);
};
exports.oAuthSignOutRedirect = oAuthSignOutRedirect;
